module.exports = __webpack_public_path__ + "static/media/logo_explore_trondelag_white.a1716694.png";